var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// https://react-typescript-cheatsheet.netlify.app/docs/basic/getting-started/error_boundaries/
import { Component } from 'react';
import * as Sentry from '@sentry/react';
var AppErrorBoundary = /** @class */ (function (_super) {
    __extends(AppErrorBoundary, _super);
    function AppErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasError: false,
        };
        return _this;
    }
    AppErrorBoundary.getDerivedStateFromError = function (_) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    };
    AppErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        // Setting captureContext specific to this Error Boundary
        // If we want to have different Error Boundaries, the new Error Boundary should have different capture context
        var context = function (scope) {
            scope.setTag('errorBoundary', 'AppErrorBoundary');
            return scope;
        };
        Sentry.captureException(error, context);
    };
    AppErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            // We don't want to render any fallback UI yet
            return this.props.children;
        }
        return this.props.children;
    };
    return AppErrorBoundary;
}(Component));
export default AppErrorBoundary;
